// home.jsx
// autor: WdePaula MVinfo
// data/hora: 01/10/24 | 21h00
// data/hora: 25/10/25 | 21h31 | melhorias do site proposta por manus.ia

import React, { useState, useEffect, useRef } from "react";
import Menu from "../Components/menu";
import Banner from "../Components/banner";
import Features from "../Components/features";
import Categorias from "../Components/categorias";
import Fotos from "../Components/fotos";
// import AgendexCliente from "../Components/appcliente";
import Precos from "../Components/precos";
import Footer from "../Components/footer";

function Site() {
    const [activeSection, setActiveSection] = useState('home');

    const bannerRef = useRef(null);
    const featuresRef = useRef(null);
    const categoriasRef = useRef(null);
    const fotosRef = useRef(null);
    // const appclienteRef = useRef(null);
    const precoRef = useRef(null);
    const footerRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const sections = [
                { id: 'home', ref: bannerRef },
                { id: 'vantagens', ref: featuresRef },
                { id: 'categorias', ref: categoriasRef },
                { id: 'fotos', ref: fotosRef },
                // { id: 'agendex-cliente', ref: appclienteRef },
                { id: 'precos', ref: precoRef },
                { id: 'contato', ref: footerRef }
            ];

            const currentSection = sections.find(section => {
                const element = section.ref.current;
                if (element) {
                    const rect = element.getBoundingClientRect();
                    return rect.top >= 0 && rect.top <= window.innerHeight / 2;
                }
                return false;
            });

            if (currentSection && currentSection.id !== activeSection) {
                setActiveSection(currentSection.id);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [activeSection]);

    

    return (
        <>
            <Menu activeSection={activeSection} />
            <section id="banner" ref={bannerRef}>
                <Banner />
            </section>
            <section id="features" ref={featuresRef}>
                <Features />
            </section>
            <section id="categorias" ref={categoriasRef}>
                <Categorias />
            </section>
            <section id="fotos" ref={fotosRef}>
                <Fotos />
            </section>
            {/* <section id="appcliente" ref={appclienteRef}>
                <AgendexCliente />
            </section> */}
            <section id="preco" ref={precoRef}>
                <Precos />
            </section>
            <section id="footer" ref={footerRef}>
                <Footer />
            </section>
        </>
    );
}

export default Site;